import { SetStateAction, useContext, useEffect, useRef, useState } from "react";
import { Button, MenuItem, Paper, Select, Snackbar, TableContainer, TextField, Toolbar, Typography } from "@mui/material";
import React from "react";
import { CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { useLocation } from "react-router-dom";
import { del, get, post, post_file } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { Alert } from "../../../Components/Alert/Alert";
import LoadingVulpesSmall from "../../../Styles/Loader/loadingSmall";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { ICabecalho5D } from "../../../Interfaces/cadernos/caderno5/interfaces5D";
import BasicPopover from "../../../Components/Popover";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { Modalshowpdf } from "../../../Components/VerPdf/modal_show_pdf";


interface CabecalhoForm_prop {
  set_obj_anexo_cabecalho_selecionado: React.Dispatch<SetStateAction<ICabecalho5D | undefined>>;
  obj_anexo_cabecalho_selecionado: ICabecalho5D | undefined;
}

export const CabecalhoForm: React.FC<CabecalhoForm_prop> = ({
  obj_anexo_cabecalho_selecionado
  , set_obj_anexo_cabecalho_selecionado }) => {
  const auth = useContext(AuthContext);

  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IZonaHomogenea>();
  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IZonaHomogenea[]>([]);
  const [cultura_selecionada, set_cultura_selecionada] = useState<any>();

  const [parcela_selecionada, set_parcela_selecionada] = useState<IZonaHomogenea>();
  const [parcelas_lista, set_parcelas_lista] = useState<IZonaHomogenea[]>([]);

  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<ICabecalho5D>();
  const [obj_anexo_cabecalho_lista, set_obj_anexo_cabecalho_lista] = useState<ICabecalho5D[]>();
  const [obj_anexo_cabecalho_to_edit, set_obj_anexo_cabecalho_to_edit] = useState<ICabecalho5D>();

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);

  const [flag_editar_cabecalho, set_flag_editar_cabecalho] = useState(false)

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [error_esperada, set_error_esperada] = React.useState(false);
  const [error_obtida, set_error_obtida] = React.useState(false);
  const [error_n_planta, set_error_n_planta] = React.useState(false);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState("");

  const fileInputRef = useRef<HTMLInputElement>(null);

  const [open_dialog_eliminar_ficheiro, set_open_dialog_eliminar_ficheiro] = useState(false);
  const [open_dialog_editar_ficheiro, set_open_dialog_editar_ficheiro] = useState(false);

  const [open_modal_show_pdf, set_open_modal_show_pdf] = useState(false);
  const [pdf_link, set_pdf_link] = useState("");
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);
  const [isEditingCultura, setIsEditingCultura] = useState(false);

  const handleCloseDialog = () => {
    set_error_esperada(false)
    set_error_obtida(false)
    set_error_n_planta(false)
    set_flag_editar_cabecalho(false)
    set_obj_anexo_cabecalho_to_edit(undefined)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const uploadDocumento = async (selectedFile: File) => {
    if (!selectedFile) {
      setMessage("Nenhum ficheiro selecionado.");
      setOpenSnackError(true);
      return;
    }

    if (!obj_anexo_cabecalho || !obj_anexo_cabecalho.id_act_feertil_azotada) {
      setMessage("Impossível carregar o documento antes de criar cabeçalho.");
      setOpenSnackError(true);
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await post_file(auth.token.cookie_token, `/uploadFile5d/${obj_anexo_cabecalho?.id_act_feertil_azotada}`, formData);

      if (response.status === 200) {
        setMessage("Documento carregado com sucesso!");
        setOpenSnackSuccess(true);
        setFileName(response.data.result.file)
        setSelectedFile(new File([], response.data.result.file, { type: 'application/pdf' }));

        let aux = obj_anexo_cabecalho_lista?.map((el) => {
          if (el.id_act_feertil_azotada === response.data.result.id_act_feertil_azotada) {
            return response.data.result
          } else {
            return el
          }
        })

        set_obj_anexo_cabecalho_lista(aux)
      } else {
        setMessage("Erro ao carregar documento.");
        setOpenSnackError(true);
      }
    } catch (error: any) {
      func_print("uploadDocumento", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setIsLoading(false);
      setOpenSnackError(true);
    } finally {
      setIsLoading(false);
    }
  }
  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type } = event.target;
    let aux_obj_anexo: any = obj_anexo_cabecalho_to_edit === undefined ? {} : obj_anexo_cabecalho_to_edit
    set_flag_editado(true)

    if (type === "checkbox") {
      aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
      set_obj_anexo_cabecalho_to_edit(aux_obj_anexo);

    } else {

      if (name === 'esperada') {
        if (!/^\d+$/.test(value)) {
          set_error_esperada(true)
        } else {
          set_error_esperada(false)
        }
      }
      if (name === 'obtida') {
        if (!/^\d+$/.test(value)) {
          set_error_obtida(true)
        } else {
          set_error_obtida(false)
        }
      }
      if (name === 'n_planta') {
        if (!/^\d+$/.test(value)) {
          set_error_n_planta(true)
        } else {
          set_error_n_planta(false)
        }
      }

      if (name === 'esperada' || name === 'obtida') {
        if (parseFloat(value).toString() !== 'NaN') {

          set_obj_anexo_cabecalho_to_edit((old: any) => ({
            ...old,
            [name]: parseFloat(value),
          }));

        }
      } else {

        set_obj_anexo_cabecalho_to_edit((old: any) => ({
          ...old,
          [name]: value,
        }));
      }



    }
  };

  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };
  const atualizarListaZonasComCabecalhos = (
    listaZonas: any[],
    listaCabecalhos: ICabecalho5D[]
  ) => {
    const resultado = listaZonas.map((zona) => ({
      ...zona,
      culturas: [...(zona.culturas ?? [])],
    }));

    listaCabecalhos.forEach((item: ICabecalho5D) => {
      const zona = resultado.find(
        (z) => z.zona_homogenea === item.zona_homo
      );

      const novaCultura = {
        cultura: item.cultura,
        area: item.area,
      };

      if (!zona) {
        resultado.push({
          zona_homogenea: item.zona_homo,
          culturas: [novaCultura],
        });
      } else {
        const culturaExiste = zona.culturas.some(
          (c: any) => c.cultura === item.cultura
        );

        if (!culturaExiste) {
          zona.culturas.push(novaCultura);
        }
      }
    });

    return resultado;
  };


  const get_info = async () => {
    try {

      let res = await get(auth.token.cookie_token,
        `/zona_homgenea_caraterizacao/${location.state.id_rosto}`
        // `/get_reg_anexo_um__cabecalho_rosto/${location.state.id_rosto}`
      );
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_act_fertil_azotada_cabecalho_rosto/${location.state.id_rosto}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );

      let res_parcelas = await get(auth.token.cookie_token,
        `/parcela_caraterizacao_lista/${location.state.id_rosto}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );
      if (res.status === 200 && res_cabecalho.status === 200 && res_parcelas.status === 200) {
        if (res.data.result.length !== 0) {
          const resultado = atualizarListaZonasComCabecalhos(
            res.data.result,
            res_cabecalho.data.result
          );

          set_especie_ou_lote_homegenio_lista(resultado);
          set_especie_ou_lote_homegenio_selecionada(resultado[0])
          set_cultura_selecionada(resultado[0].culturas[0])

          if (res_cabecalho.data.result.length !== 0) {
            set_obj_anexo_cabecalho_lista(res_cabecalho.data.result)
            let obj_aux = res_cabecalho.data.result?.find((el: ICabecalho5D) => el.zona_homo === resultado[0].zona_homogenea)
            if (obj_aux === undefined) {

              set_flag_editar_cabecalho(true)

            } else {
              set_obj_anexo_cabecalho_to_edit(obj_aux)
              set_obj_anexo_cabecalho_selecionado(obj_aux)
              set_obj_anexo_cabecalho(obj_aux)
              if (obj_aux.file) {
                setFileName(obj_aux.file)
                setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
              }
              set_cultura_selecionada(resultado[0].culturas.find((el: any) => el.cultura === obj_aux.cultura))

            }
          } else {
            set_flag_editar_cabecalho(true)
          }
        }

        if (res_parcelas.data.result.length !== 0) {
          set_parcelas_lista(res_parcelas.data.result.sort(
            (a: any, b: any) => a.n_sequencia - b.n_sequencia
          ));
          set_parcela_selecionada(undefined)
        }


      } else {
        setMessage("Erro a carregar informação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const handle_change_cultura = (cultura_selecionad: string) => {

    let aux_cultura_selecionada = especie_ou_lote_homegenio_selecionada?.culturas.find((el: any) => el.cultura === cultura_selecionad)

    set_cultura_selecionada(aux_cultura_selecionada)

    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho5D) => el.zona_homo === especie_ou_lote_homegenio_selecionada?.zona_homogenea && aux_cultura_selecionada.cultura === el.cultura)

    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      setFileName('')
      setSelectedFile(null);
    } else {
      set_flag_editar_cabecalho(false)

      if (obj_aux.file) {
        setFileName(obj_aux.file)
        setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
      } else {
        setFileName('')
        setSelectedFile(null);
      }
    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)

  }

  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)
    set_parcela_selecionada(undefined)

    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho5D) => el.zona_homo === zona_homogenea_selecionada)
    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      setFileName('')
      setSelectedFile(null);
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas[0])

    } else {
      set_flag_editar_cabecalho(false)
      if (obj_aux.file) {
        setFileName(obj_aux.file)
        setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
      } else {
        setFileName('')
        setSelectedFile(null);
      }
      set_cultura_selecionada(aux_obj_zona_homogenea_selecionada?.culturas.find((el) => el.cultura === obj_aux?.cultura))

    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)
  }
  const handle_change_parcela = (parcela_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)
    set_parcela_selecionada(undefined)
    set_especie_ou_lote_homegenio_selecionada(undefined)

    const [n_sequencia, sub_parcela] = parcela_selecionada.split(' - ');

    let aux_obj_parcela_selecionada = parcelas_lista.find((el: IZonaHomogenea) => el.n_sequencia.toString() === n_sequencia.toString() && el.sub_parcela.toString() === sub_parcela.toString())

    set_parcela_selecionada(aux_obj_parcela_selecionada)
    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho5D) => el.n_sequencia !== null && el.n_sequencia.toString() === n_sequencia.toString() && el.n_subparcela.toString() === sub_parcela.toString())

    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
      setFileName('')
      setSelectedFile(null);
    } else {
      set_flag_editar_cabecalho(false)
      if (obj_aux.file) {
        setFileName(obj_aux.file)
        setSelectedFile(new File([], obj_aux.file, { type: 'application/pdf' }));
      } else {
        setFileName('')
        setSelectedFile(null);
      }
    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)
  }

  const handle_criar_cabecalho = async () => {
    if (error_esperada || error_obtida || error_n_planta) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {

      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "new_reg_act_fertil_azotada_cabecalho", {
          payload: {
            id_act_feertil_azotada: 0,
            zona_homo: parcela_selecionada !== undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.area === undefined ? null : parcela_selecionada?.area
              : cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.cultura === undefined ? null : parcela_selecionada?.cultura
              : cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            n_sequencia: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.n_sequencia === undefined ? null : parcela_selecionada?.n_sequencia.toString()
              : especie_ou_lote_homegenio_selecionada?.n_sequencia === undefined ? null : especie_ou_lote_homegenio_selecionada?.n_sequencia.toString(),
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            n_subparcela: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.sub_parcela === undefined ? null : parcela_selecionada?.sub_parcela.toString()
              : especie_ou_lote_homegenio_selecionada?.sub_parcela === undefined ? null : especie_ou_lote_homegenio_selecionada?.sub_parcela.toString(),
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            metodo_rega: obj_anexo_cabecalho_to_edit?.metodo_rega === undefined ? null : obj_anexo_cabecalho_to_edit?.metodo_rega,
            obtida: obj_anexo_cabecalho_to_edit?.obtida === undefined ? null : obj_anexo_cabecalho_to_edit?.obtida,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            data_plantacao: obj_anexo_cabecalho_to_edit?.data_plantacao === undefined ? null : obj_anexo_cabecalho_to_edit?.data_plantacao,
            n_planta: obj_anexo_cabecalho_to_edit?.n_planta === undefined ? null : obj_anexo_cabecalho_to_edit?.n_planta,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })
        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          if (obj_anexo_cabecalho_lista?.length === 0 || obj_anexo_cabecalho_lista === undefined) {
            set_obj_anexo_cabecalho_lista([data.data.result])

          } else {
            set_obj_anexo_cabecalho_lista((old: any) => [...old, data.data.result])

          }
          set_error_esperada(false)
          set_error_obtida(false)
          set_error_n_planta(false)
          set_flag_editado(false)

          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          set_flag_editar_cabecalho(false)
          if (data.data.result.file) {
            setFileName(data.data.result.file)
            setSelectedFile(new File([], data.data.result.file, { type: 'application/pdf' }));
          } else {
            setFileName('')
            setSelectedFile(null);
          }
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error) {
        func_print('handle_criar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }
  const handle_editar_cabecalho = async () => {
    if (error_esperada || error_obtida || error_n_planta) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "update_reg_act_fertil_azotada_cabecalho", {
          payload: {
            id_act_feertil_azotada: obj_anexo_cabecalho_to_edit?.id_act_feertil_azotada,
            zona_homo: parcela_selecionada !== undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? null : especie_ou_lote_homegenio_selecionada?.zona_homogenea,
            area: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.area === undefined ? null : parcela_selecionada?.area
              : cultura_selecionada?.area === undefined ? null : cultura_selecionada?.area,
            cultura: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.cultura === undefined ? null : parcela_selecionada?.cultura
              : cultura_selecionada?.cultura === undefined ? null : cultura_selecionada?.cultura,
            n_sequencia: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.n_sequencia === undefined ? null : parcela_selecionada?.n_sequencia.toString()
              : especie_ou_lote_homegenio_selecionada?.n_sequencia === undefined ? null : especie_ou_lote_homegenio_selecionada?.n_sequencia.toString(),
            compasso: obj_anexo_cabecalho_to_edit?.compasso === undefined ? null : obj_anexo_cabecalho_to_edit?.compasso,
            n_subparcela: especie_ou_lote_homegenio_selecionada === undefined ?
              parcela_selecionada?.sub_parcela === undefined ? null : parcela_selecionada?.sub_parcela.toString()
              : especie_ou_lote_homegenio_selecionada?.sub_parcela === undefined ? null : especie_ou_lote_homegenio_selecionada?.sub_parcela.toString(),
            porta_enxerto: obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? null : obj_anexo_cabecalho_to_edit?.porta_enxerto,
            n_planta: obj_anexo_cabecalho_to_edit?.n_planta === undefined ? null : obj_anexo_cabecalho_to_edit?.n_planta,
            metodo_rega: obj_anexo_cabecalho_to_edit?.metodo_rega === undefined ? null : obj_anexo_cabecalho_to_edit?.metodo_rega,
            obtida: obj_anexo_cabecalho_to_edit?.obtida === undefined ? null : obj_anexo_cabecalho_to_edit?.obtida,
            esperada: obj_anexo_cabecalho_to_edit?.esperada === undefined ? null : obj_anexo_cabecalho_to_edit?.esperada,
            data_plantacao: obj_anexo_cabecalho_to_edit?.data_plantacao === undefined ? null : obj_anexo_cabecalho_to_edit?.data_plantacao,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })

        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editar_cabecalho(false)
          set_error_esperada(false)
          set_error_obtida(false)
          set_error_n_planta(false)
          set_flag_editado(false)
          set_obj_anexo_cabecalho_to_edit(data.data.result)
          set_obj_anexo_cabecalho(data.data.result)
          set_obj_anexo_cabecalho_selecionado(data.data.result)
          let aux = obj_anexo_cabecalho_lista?.map((el) => {
            if (el.id_act_feertil_azotada === data.data.result.id_act_feertil_azotada) {
              return data.data.result
            } else {
              return el
            }
          })
          set_obj_anexo_cabecalho_lista(aux)

          if (data.data.result.file) {
            setFileName(data.data.result.file)
            setSelectedFile(new File([], data.data.result.file, { type: 'application/pdf' }));
          } else {
            setFileName('')
            setSelectedFile(null);
          }
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print('handle_editar_cabecalho', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }

  }
  const handle_delete_cabecalho = async () => {
    try {
      set_open_dialog_tem_a_certeza_que_quer_eliminar(false)
      setIsLoading(true);
      let data = await del(auth.token.cookie_token, `delete__reg_act_fertil_azotada_cabecalho/${obj_anexo_cabecalho?.id_act_feertil_azotada}`)
      if (data.status === 200) {
        let lista_aux: any = obj_anexo_cabecalho_lista?.filter((el) => el.id_act_feertil_azotada !== obj_anexo_cabecalho?.id_act_feertil_azotada)
        setMessage("Eliminado com sucesso!");
        setOpenSnackSuccess(true);
        set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho_selecionado(undefined)
        set_obj_anexo_cabecalho(undefined)
        set_obj_anexo_cabecalho_to_edit(undefined)
        set_flag_editar_cabecalho(true)
        setSelectedFile(null)
        setFileName('')
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {

      func_print('handle_delete_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
    }
  }
  const handleEdit = () => {
    set_open_dialog_editar_ficheiro(true);
  };

  const handleConfirmEdit = () => {
    set_open_dialog_editar_ficheiro(false);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDelete = () => {
    set_open_dialog_eliminar_ficheiro(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsLoading(true);

      const payload = {
        payload: {
          ...obj_anexo_cabecalho,
        }
      };

      const response = await post(auth.token.cookie_token,
        `/update_file_reg_act_fertil_azotada_cabecalho`,
        payload
      );

      if (response.status === 200) {
        setFileName("");
        set_open_dialog_eliminar_ficheiro(false);
        setMessage("Documento eliminado com sucesso!");
        setOpenSnackSuccess(true);
        setSelectedFile(null);
        let aux = obj_anexo_cabecalho_lista?.map((el) => {
          if (el.id_act_feertil_azotada === response.data.result.id_act_feertil_azotada) {
            return response.data.result
          } else {
            return el
          }
        })

        set_obj_anexo_cabecalho_lista(aux)
      } else {
        setMessage("Erro ao eliminar o documento!");
        setOpenSnackError(true);
      }
    } catch (error) {
      func_print('handleConfirmDelete', error, true);
      setMessage("Erro ao eliminar o documento!");
      setOpenSnackError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewDocument = () => {
    if (selectedFile) {
      set_pdf_link(fileName);
      set_open_modal_show_pdf(true);
    }
  };

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);

  return (
    <form>
      <CustomThemeProvider>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {isLoading ?
            <LoadingVulpesSmall />
            :
            <Toolbar
              style={{
                paddingTop: 3,
                paddingBottom: 10,
                fontFamily: "candara",
                display: "flex",
                flexDirection: 'column',
              }}
            >
              <div style={{
                width: '100%',

              }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingBottom: 10
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: 'row',
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: 600,
                        fontSize: 20,
                        fontFamily: "candara",
                      }}
                    >
                      5D - Registo de Atividades de Fertilização Azotada
                    </h1>
                    <BasicPopover
                      text={
                        "Registo obrigatório para o regime ecológico Promoção da Fertilização Orgânica. \n\nPretende-se que o beneficiário registe a aplicação de fertilizantes orgânicos e inorgânicos com base no plano de fertilização. \n\nRegisto pode ser utilizado para cumprimento dos requisitos de: \n- Programa de Ação das Zonas Vulneráveis, Portaria n.º 259/2012, sendo obrigatório o preenchimento dos campos que antecedem o quadro 1, exceto os campos 'compasso', 'porta-enxertos', 'n.º de plantas' e 'data de plantação', o quadro 1 - quantidades de azoto aplicadas e o quadro 2 - azoto fornecido pela água de rega. \n- Condicionalidade, parte dos indicadores do RLG2 da Portaria n.º 54-Q/2023, sendo obrigatório o preenchimento dos quadros 1 e 2 com complemento do Anexo 1 - indicadores 3.1, 3.3 e 3.4."
                      }
                    />
                  </div>
                  <div>

                    {obj_anexo_cabecalho === undefined ? <></> : selectedFile === null ?
                      is_historico === true ? <></> :

                        <Button
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          startIcon={<FileUploadIcon />}
                          style={{
                            backgroundColor: cores.cor1,
                            maxHeight: 30,
                            width: 250,
                            marginRight: 10
                          }}
                        >
                          Carregar documento
                          <input
                            type="file"
                            accept="application/pdf"
                            hidden
                            multiple={false}
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              if (file) {
                                //setSelectedFile(file);
                                uploadDocumento(file);
                              }
                            }}
                          />
                        </Button>
                      : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <Button
                            style={{
                              backgroundColor: cores.cor1,
                              color: 'white',
                              maxHeight: 30,
                              width: 200,
                            }}
                            startIcon={<VisibilityIcon />}
                            onClick={handleViewDocument}
                          >
                            Ver documento
                          </Button>
                          {
                            is_historico === true ? <></> :
                              <>
                                <Button
                                  style={{
                                    backgroundColor: cores.cor1,
                                    color: 'white',
                                    minWidth: '40px',
                                    maxHeight: 30,
                                  }}
                                  onClick={handleEdit}
                                >
                                  <FileUploadIcon />
                                </Button>
                                <Button
                                  style={{
                                    backgroundColor: cores.cor1,
                                    color: 'white',
                                    minWidth: '40px',
                                    maxHeight: 30,
                                  }}
                                  onClick={handleDelete}
                                >
                                  <DeleteIcon />
                                </Button>
                                <input
                                  ref={fileInputRef}
                                  type="file"
                                  accept="application/pdf"
                                  hidden
                                  multiple={false}
                                  onChange={(event) => {
                                    const file = event.target.files?.[0];
                                    if (file) {
                                      setSelectedFile(file);
                                      uploadDocumento(file);
                                    }
                                  }}
                                />
                              </>
                          }
                        </div>
                      )}



                  </div>
                </div>
                <div style={{
                  width: '100%',
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',

                }}>
                  {
                    parcelas_lista.length === 0 || especie_ou_lote_homegenio_lista.length === 0 ? <></> :

                      obj_anexo_cabecalho === undefined ?
                        is_historico === true ? <></> :

                          <ButtonCadernos

                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_criar_cabecalho() }}
                          />
                        :
                        flag_editar_cabecalho === true ?
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {
                                set_error_esperada(false)
                                set_error_obtida(false)
                                set_error_n_planta(false)
                                set_flag_editar_cabecalho(false)
                                set_obj_anexo_cabecalho_to_edit(undefined)
                              }
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_editar_cabecalho() }}
                          /> :
                          is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoApagar
                              mostrarBotaoEditar
                              aoClicarApagar={() => { set_open_dialog_tem_a_certeza_que_quer_eliminar(true) }}
                              aoClicarEditar={() => {
                                set_flag_editar_cabecalho(true)
                                set_obj_anexo_cabecalho_to_edit(obj_anexo_cabecalho)

                              }}
                            />


                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.25,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Zona Homogénea
                    <Select
                      value={especie_ou_lote_homegenio_selecionada?.zona_homogenea === undefined ? '' : especie_ou_lote_homegenio_selecionada?.zona_homogenea}
                      label={''}
                      name={'zona_homogenea'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                    >

                      {especie_ou_lote_homegenio_lista
                        ?.filter((item: any) => item?.zona_homogenea)
                        .sort((a, b) =>
                          (a.zona_homogenea ?? '').localeCompare(b.zona_homogenea ?? '', 'pt', {
                            sensitivity: 'base',
                          })
                        ).map((item: IZonaHomogenea, key) => {

                          return (
                            <MenuItem key={key} value={item.zona_homogenea}>
                              <Typography
                                style={{
                                  fontSize: 14,
                                  fontFamily: "candara",
                                }}
                              >
                                {item.zona_homogenea}
                              </Typography>
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    Ou

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <BasicPopover
                      text={
                        " N.º sequencial da parcela - Preencher com o n.º sequencial da parcela constante do iE do agricultor e anexar o respetivo iE.  \nParcela é a área delimitada geograficamente com uma identificação única conforme registado no Sistema de Identificação Parcelar (iSIP). \nO iE é o documento de caraterização da exploração agrícola resultante da identificação das parcelas da exploração no iSIP; esta caraterização da exploração encontra-se no documento IFAP e nele consta o n.º sequencial da parcela ou baldio; n.º do parcelário; nome da parcela; área da parcela; IQFP, entre outros. "
                      }
                    />
                    N.º Seq. Parcela:

                    <Select
                      value={parcela_selecionada?.n_sequencia === undefined && parcela_selecionada?.sub_parcela === undefined ? '' : parcela_selecionada?.n_sequencia + ' - ' + parcela_selecionada?.sub_parcela}
                      label={''}
                      name={'n_sequencia'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_parcela(e.target.value)}
                    >

                      {parcelas_lista.map((item: IZonaHomogenea, key) => {

                        return (
                          <MenuItem key={key} value={item.n_sequencia + ' - ' + item.sub_parcela}>

                            <Typography
                              style={{
                                fontSize: 14,
                                fontFamily: "candara",
                              }}
                            >
                              {item.n_sequencia + ' -> nº subparcela: ' + item.sub_parcela}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <BasicPopover
                      text={
                        "Preencher com o n.º de subparcela constante no iE para a corresponde parcela com o n.º sequencial registado no campo anterior. \nEntende-se por Subparcela a área corresponde à porção contínua de terreno homogéneo com a mesma ocupação de solo existente numa mesma parcela e que consta do documento iE "
                      }
                    />
                    N.º Subparcela: {parcela_selecionada?.sub_parcela}

                  </div>

                  <div style={{
                    display: "flex",
                    flex: 0.15,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Área (ha): {especie_ou_lote_homegenio_selecionada === undefined ? parcela_selecionada?.area.toFixed(2) : cultura_selecionada?.area.toFixed(2)}
                  </div>

                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>

                    Método de rega:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="metodo_rega"
                          value={obj_anexo_cabecalho_to_edit?.metodo_rega === undefined ? '' : obj_anexo_cabecalho_to_edit?.metodo_rega}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.metodo_rega === undefined ? '' : obj_anexo_cabecalho?.metodo_rega}
                        </div>

                    }

                  </div>

                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.2,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    gap: 8,
                    border: '1px solid silver',
                    padding: 8,
                    borderRadius: 5,
                    minWidth: 400,

                  }}>
                    Cultura e variedade:
                    {


                      // se o cabeçalho tiver criado -> obj_anexo_cabecalho
                      obj_anexo_cabecalho !== undefined ?
                        // se eu estiver a editar o cabeçalho -> obj_anexo_cabecalho_to_edit
                        flag_editar_cabecalho === true ?
                          // se eu escolher nao editar a cultura do cabeçalho que existe -> obj_anexo_cabecalho_to_edit
                          // !isEditingCultura ?
                          //   obj_anexo_cabecalho_to_edit?.cultura === undefined ? '' : obj_anexo_cabecalho_to_edit?.cultura
                          //   :
                          // se eu escolher editar a cultura do cabeçalho que ja existe -> obj_anexo_cabecalho_to_edit + parcela_selecionada +especie_ou_lote_homegenio_selecionada
                          especie_ou_lote_homegenio_selecionada !== undefined ? // se eu tiver selecionado uma zona homogenea -> especie_ou_lote_homegenio_selecionada
                            !isEditingCultura ?
                              <Select
                                value={cultura_selecionada?.cultura ?? ''}
                                name={'cultura'}
                                sx={{
                                  fontSize: 14,
                                  fontFamily: "verdana",
                                  minWidth: 200,
                                }}
                                onChange={(e) => {
                                  handle_change_cultura(e.target.value)
                                }}
                              >
                                {especie_ou_lote_homegenio_selecionada?.culturas
                                  .sort((a, b) =>
                                    (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                                      sensitivity: 'base',
                                    })
                                  )
                                  .map((item: any, key) => (
                                    <MenuItem key={key} value={item.cultura}>
                                      <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                                        {item.cultura}
                                      </Typography>
                                    </MenuItem>
                                  ))}
                              </Select>
                              :
                              <CustomTextField
                                name="cultura"
                                minWidth={200}
                                value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                                onChange={(e: any) => {

                                  set_especie_ou_lote_homegenio_selecionada((old: any) => ({
                                    ...old,
                                    culturas: old.culturas.map((el: any) => {
                                      if (el.cultura === cultura_selecionada?.cultura) {
                                        return {
                                          ...el,
                                          cultura: e.target.value,
                                        }
                                      } else {
                                        return el
                                      }
                                    })
                                  }))
                                  set_cultura_selecionada((old: any) => ({
                                    ...old,
                                    cultura: e.target.value,
                                  }))
                                }}
                              />
                            : // se eu  tiver selecionado uma parcela -> parcela_selecionada
                            <CustomTextField
                              name="cultura"
                              minWidth={800}
                              value={obj_anexo_cabecalho_to_edit?.cultura === undefined ? '' : obj_anexo_cabecalho_to_edit?.cultura}
                              onChange={(e: any) => {
                                set_parcela_selecionada((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                                set_obj_anexo_cabecalho_to_edit((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                              }}
                            />

                          :
                          // se eu nao estiver a editar o cabeçalho -> obj_anexo_cabecalho
                          especie_ou_lote_homegenio_selecionada !== undefined ?
                            <Select
                              value={cultura_selecionada?.cultura ?? ''}
                              name={'cultura'}
                              sx={{
                                fontSize: 14,
                                fontFamily: "verdana",
                                minWidth: 200,
                              }}
                              onChange={(e) => {
                                handle_change_cultura(e.target.value)
                              }}
                            >
                              {especie_ou_lote_homegenio_selecionada?.culturas
                                .sort((a, b) =>
                                  (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                                    sensitivity: 'base',
                                  })
                                )
                                .map((item: any, key) => (
                                  <MenuItem key={key} value={item.cultura}>
                                    <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                                      {item.cultura}
                                    </Typography>
                                  </MenuItem>
                                ))}
                            </Select>
                            :
                            obj_anexo_cabecalho?.cultura === undefined ? '' : obj_anexo_cabecalho?.cultura
                        :
                        //  se o cabeçalho nao esta criado
                        especie_ou_lote_homegenio_selecionada !== undefined ? // se eu tiver selecionado uma zona homogenea -> especie_ou_lote_homegenio_selecionada
                          !isEditingCultura ?
                            <Select
                              value={cultura_selecionada?.cultura ?? ''}
                              name={'cultura'}
                              sx={{
                                fontSize: 14,
                                fontFamily: "verdana",
                                minWidth: 200,
                              }}
                              onChange={(e) => {
                                handle_change_cultura(e.target.value)
                              }}
                            >
                              {especie_ou_lote_homegenio_selecionada?.culturas
                                .sort((a, b) =>
                                  (a?.cultura ?? '').localeCompare(b?.cultura ?? '', 'pt', {
                                    sensitivity: 'base',
                                  })
                                )
                                .map((item: any, key) => (
                                  <MenuItem key={key} value={item.cultura}>
                                    <Typography sx={{ fontSize: 14, fontFamily: "candara" }}>
                                      {item.cultura}
                                    </Typography>
                                  </MenuItem>
                                ))}
                            </Select>
                            :
                            <CustomTextField
                              name="cultura"
                              minWidth={200}
                              value={cultura_selecionada?.cultura === undefined ? '' : cultura_selecionada?.cultura}
                              onChange={(e: any) => {

                                set_especie_ou_lote_homegenio_selecionada((old: any) => ({
                                  ...old,
                                  culturas: old.culturas.map((el: any) => {
                                    if (el.cultura === cultura_selecionada?.cultura) {
                                      return {
                                        ...el,
                                        cultura: e.target.value,
                                      }
                                    } else {
                                      return el
                                    }
                                  })
                                }))
                                set_cultura_selecionada((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                              }}
                            />
                          : // se eu  tiver selecionado uma parcela -> parcela_selecionada
                          !isEditingCultura ?
                            parcela_selecionada?.cultura === undefined ? '' : parcela_selecionada?.cultura
                            :
                            <CustomTextField
                              name="cultura"
                              minWidth={800}
                              value={parcela_selecionada?.cultura === undefined ? '' : parcela_selecionada?.cultura}
                              onChange={(e: any) => {
                                set_parcela_selecionada((old: any) => ({
                                  ...old,
                                  cultura: e.target.value,
                                }))
                              }}
                            />
                    }


                    <div style={{
                      display: "flex"
                      // , alignSelf: "flex-start",
                    }}>
                      {
                        flag_editar_cabecalho === false ? <></> :
                          isEditingCultura ?
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                            :
                            <ButtonCadernos
                              mostrarBotaoEditar

                              aoClicarEditar={() => { setIsEditingCultura(prev => !prev) }}
                            />
                      }


                    </div>

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.125,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente."
                      }
                    />
                    Compasso:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="compasso"
                          value={obj_anexo_cabecalho_to_edit?.compasso === undefined ? '' : obj_anexo_cabecalho_to_edit?.compasso}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.compasso === undefined ? '' : obj_anexo_cabecalho?.compasso}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.125,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    <BasicPopover
                      text={
                        "Preencher apenas para cultura permanente."
                      }
                    />
                    Porta-enxerto:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="porta_enxerto"
                          value={obj_anexo_cabecalho_to_edit?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho_to_edit?.porta_enxerto}
                          onChange={onInputEditTableChange_cabecalho}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.porta_enxerto === undefined ? '' : obj_anexo_cabecalho?.porta_enxerto}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.125,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    nº de plantas:
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="n_planta"
                          value={obj_anexo_cabecalho_to_edit?.n_planta === undefined ? '' : obj_anexo_cabecalho_to_edit?.n_planta}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_n_planta}
                          helperText={error_n_planta ? 'Apenas números são aceites' : ""}

                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.n_planta === undefined ? '' : obj_anexo_cabecalho?.n_planta}
                        </div>

                    }
                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    <BasicPopover
                      text={
                        "Preencher com a data de plantação da cultura."
                      }
                    />
                    Data de plantação:
                    {
                      flag_editar_cabecalho === true ?
                        <TextField
                          variant="filled"
                          type="date"
                          defaultValue={obj_anexo_cabecalho_to_edit?.data_plantacao}
                          disabled={!flag_editar_cabecalho}
                          name="data_plantacao"
                          value={obj_anexo_cabecalho_to_edit?.data_plantacao === undefined ? '' : obj_anexo_cabecalho_to_edit?.data_plantacao}
                          onChange={onInputEditTableChange_cabecalho}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.data_plantacao === undefined ? '' : obj_anexo_cabecalho?.data_plantacao}
                        </div>

                    }
                  </div>


                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',


                  }}>
                    Produção total:

                  </div>

                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',


                  }}>
                    Esperada (Ton/ha):
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="esperada"
                          value={obj_anexo_cabecalho_to_edit?.esperada === undefined ? '' : obj_anexo_cabecalho_to_edit?.esperada}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_esperada}
                          helperText={error_esperada ? 'Apenas números são aceites' : ""}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.esperada === undefined ? '' : obj_anexo_cabecalho?.esperada}
                        </div>

                    }

                  </div>
                  <div style={{
                    display: "flex",
                    flex: 0.33,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Obtida (Ton/ha):
                    {
                      flag_editar_cabecalho === true ?
                        <CustomTextField
                          disabled={!flag_editar_cabecalho}
                          name="obtida"
                          value={obj_anexo_cabecalho_to_edit?.obtida === undefined ? '' : obj_anexo_cabecalho_to_edit?.obtida}
                          onChange={onInputEditTableChange_cabecalho}
                          error={error_obtida}
                          helperText={error_obtida ? 'Apenas números são aceites' : ""}
                        />
                        :
                        <div style={{
                          paddingLeft: 5,
                        }}>
                          {obj_anexo_cabecalho?.obtida === undefined ? '' : obj_anexo_cabecalho?.obtida}
                        </div>

                    }

                  </div>


                </div>

              </div>
            </Toolbar>

          }
        </TableContainer>
      </CustomThemeProvider>
      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
        onConfirm={handle_delete_cabecalho}
        message="Deseja eliminar o registo?"
      />

      <ConfirmDialog
        open={open_dialog_eliminar_ficheiro}
        onClose={() => set_open_dialog_eliminar_ficheiro(false)}
        onConfirm={handleConfirmDelete}
        message="Deseja eliminar o documento?"
      />
      <ConfirmDialog
        open={open_dialog_editar_ficheiro}
        onClose={() => set_open_dialog_editar_ficheiro(false)}
        onConfirm={handleConfirmEdit}
        message="Ao enviar um novo ficheiro substitui o atual. Pretender continuar?"
      />
      <Modalshowpdf
        open_modal_show_pdf={open_modal_show_pdf}
        set_open_modal_show_pdf={set_open_modal_show_pdf}
        link_file={pdf_link}
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </form>
  );
};
